import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import moment from 'moment'
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import styled from "styled-components";


const SpanTitle = styled.span`
    font-size:18px;
    color:#041E42;
    font-weight:bold;
`
const SpanData = styled.span`
    margin-right:50px;
    font-size:18px;
    color:#041E42;
    font-weight:bold;
    
`
const FooterGroup = styled.p`
    text-align:right;
    font-size:18px;
    color:#041E42;
    font-weight:bold;
`
const HeaderTable = styled.div`
    text-align:center;
    color:#041E42;
    font-size:24px;
`

const IconHeader = styled(AirplaneTicketIcon)`
    vertical-align:text-bottom;
    margin-right:10px;
    width: 30px !important;
    height: 30px !important;
`

const HeaderTitulo = styled.span`
    vertical-align:text-bottom;
    margin-bottom:10px;
`


const TabelaBilhetes = (props) => {
    const [bilhetes, setBilhetes] = useState([]);
    const [totalTarifa, setTotalTarifa] = useState(0.00);
    const [totalTaxa, setTotalTaxa] = useState(0.00);
    const [totalCartao, setTotalCartao] = useState(0.00);
    const [totalComissao, setTotalComissao] = useState(0.00);
    const [totalIncentivo, setTotalIncentivo] = useState(0.00);
    const [totalDesconto, setTotalDesconto] = useState(0.00);
    const [totalImposto, setTotalImposto] = useState(0.00);
    const [totalFee, setTotalFee] = useState(0.00);
    const [totalTxacrt, setTotalTxacrt] = useState(0.00);
    const [totalTxDu, setTotalTxDu] = useState(0.00);
    const [totalLiquido, setTotalLiquido] = useState(0.00);
    const [totalFlyPay, setTotalFlyPay] = useState(0.00);
    const [totalVenda, setTotalVenda] = useState(0.00);

    useEffect(() => {
        setBilhetes(props.fatura.bilhetes);
        setTotalTarifa(formatNumberPosMount(props.fatura.totalTarifaGeral));
        setTotalTaxa(formatNumberPosMount(props.fatura.totalTaxa));
        setTotalCartao(formatNumberPosMount(props.fatura.totalCartao));
        setTotalComissao(formatNumberPosMount(props.fatura.totalComissao));
        setTotalIncentivo(formatNumberPosMount(props.fatura.totalIncentivo));
        setTotalDesconto(formatNumberPosMount(props.fatura.totalDesconto));
        setTotalImposto(formatNumberPosMount(props.fatura.totalImposto));
        setTotalFee(formatNumberPosMount(props.fatura.totalFee));
        setTotalTxacrt(formatNumberPosMount(props.fatura.totalTxacrt));
        setTotalTxDu(formatNumberPosMount(props.fatura.totalTxDu));
        setTotalLiquido(formatNumberPosMount(props.fatura.totalLiquido));
        setTotalVenda(formatNumberPosMount(props.fatura.totalVenda));
        setTotalFlyPay(formatNumberPosMount(props.fatura.totalFlyPay))
    }, [bilhetes, totalTarifa, totalTaxa, totalCartao, totalComissao, totalIncentivo, totalDesconto, 
        totalImposto, totalFee, totalTxacrt, totalTxDu, totalLiquido, totalFlyPay, totalVenda,
        props.fatura.bilhetes, props.fatura.totalTarifaGeral, props.fatura.totalTaxa, 
        props.fatura.totalCartao, props.fatura.totalComissao, props.fatura.totalIncentivo,
        props.fatura.totalDesconto, props.fatura.totalImposto, props.fatura.totalFee,props.fatura.totalFlyPay,
        props.fatura.totalTxacrt, props.fatura.totalTxDu, props.fatura.totalLiquido, props.fatura.totalVenda]);

    
    const formatNumberPosMount = (number) => {
        const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
        const formatNumber = new Intl.NumberFormat('pt-BR', options)
        return number !== "undefined" ? formatNumber.format(number) : 0.00;
    }

    const header = (
        <HeaderTable>
            <IconHeader/><HeaderTitulo>BILHETES</HeaderTitulo>
        </HeaderTable>
    );

    let footerGroup =
        <ColumnGroup>
            <Row>
                <Column style={{ width: '400px', color: "white", backgroundColor: "#041E42" }} footer="" />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer="" />
                <Column style={{ width: '200px', color: "white", backgroundColor: "#041E42" }} footer="" />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer="Total Geral:" />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalTarifa} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalTaxa} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalFee} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalIncentivo} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalDesconto} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalImposto} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalVenda} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalFlyPay} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalTxacrt} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalLiquido} />
                <Column style={{ width: '150px', color: "white", backgroundColor: "#041E42" }} footer={totalTxDu} />
                <Column style={{ width: '200px', color: "white", backgroundColor: "#041E42" }} footer="" />
            </Row>
        </ColumnGroup>;

    const reactFooter = (totalizadores) => {
        return (
            <React.Fragment>
                <td style={{ width: '400px' }}></td>
                <td style={{ width: '150px' }}></td>
                <td style={{ width: '200px' }}></td>
                <td style={{ width: '150px' }}><FooterGroup>Total da Cia:</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.tarifa}</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.taxa}</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.fee}</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.incentivo}</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.desconto}</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.imposto}</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.totalVenda}</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.totalFlyPay}</FooterGroup></td>                
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.txadmcrt}</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.liquido}</FooterGroup></td>
                <td style={{ width: '150px' }}><FooterGroup>{totalizadores.txdu}</FooterGroup></td>
                <td style={{ width: '200px' }}></td>
            </React.Fragment>
        );
    }

    const footerTemplate = (data) => {
        let totalizadores = calculateTicketTotal(data.grupo);

        return reactFooter(totalizadores);
    }

    const headerTemplate = (data) => {
        return (
            <React.Fragment>
                <SpanTitle>Companhia:&nbsp;</SpanTitle><SpanData>{data.codcia}</SpanData>
                <SpanTitle>Emissão:&nbsp;</SpanTitle><SpanData>{data.fpagto}</SpanData>
                <SpanTitle>Tipo:&nbsp;</SpanTitle><SpanData>{data.tipoFormatado}</SpanData>
            </React.Fragment>
        );
    }

    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options)
   
    const tarifaBodyTemplate = (rowData) => {   
        let value = rowData.tarifa;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const taxaBodyTemplate = (rowData) => {
        let value = rowData.taxa;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const incentivoBodyTemplate = (rowData) => {
        let value = rowData.incentivo;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const descontoBodyTemplate = (rowData) => {
        let value = rowData.desconto;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const impostoBodyTemplate = (rowData) => {
        let value = rowData.imposto;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const feeBodyTemplate = (rowData) => {
        let value = rowData.fee;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const txacrtBodyTemplate = (rowData) => {
        let value = rowData.txadmcrt;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const liquidoBodyTemplate = (rowData) => {
        let value = rowData.liquido;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const txduBodyTemplate = (rowData) => {
        let value = rowData.txdu;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const dataEmissaoBodyTemplate = (rowData) => {
        return moment(rowData.emissao).format('DD/MM/YYYY')
    }

    const totalVendaBodyTemplate = (rowData) => {
        let value = rowData.totalVenda;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }

    const cartoFlaypayBodyTemplate = (rowData) => {
        let value = rowData.valCartFlaypay;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }
    const calculateTicketTotal = (grupo) => {
        let totalTarifa = 0;
        let totalTaxa = 0;
        let totalCartao = 0;
        let totalComissao = 0;
        let totalIncentivo = 0;
        let totalDesconto = 0;
        let totalImposto = 0;
        let totalFee = 0;
        let totalTxacrt = 0;
        let totalTxDu = 0;
        let totalLiquido = 0;
        let totalFlyPay = 0;
        let totalVenda = 0;

        if (bilhetes) {
            for (let bilhete of bilhetes) {
                if (grupo === undefined || bilhete.grupo === grupo) {
                    totalTarifa += bilhete.tarifa;
                    totalTaxa += bilhete.taxa;
                    totalCartao += bilhete.cartaoVl;
                    totalComissao += bilhete.comissao;
                    totalIncentivo += bilhete.incentivo;
                    totalDesconto += bilhete.desconto;
                    totalImposto += bilhete.imposto;
                    totalFee += bilhete.fee;
                    totalTxacrt += bilhete.txadmcrt;
                    totalLiquido += bilhete.liquido;
                    totalTxDu += bilhete.txdu;
                    totalFlyPay += bilhete.valCartFlaypay;
                    totalVenda += bilhete.totalVenda;
                }
            }
        }
        return {
            tarifa: formatNumber.format(totalTarifa),
            taxa: formatNumber.format(totalTaxa),
            cartao: formatNumber.format(totalCartao),
            comissao: formatNumber.format(totalComissao),
            incentivo: formatNumber.format(totalIncentivo),
            desconto: formatNumber.format(totalDesconto),
            imposto: formatNumber.format(totalImposto),
            fee: formatNumber.format(totalFee),
            txadmcrt: formatNumber.format(totalTxacrt),
            liquido: formatNumber.format(totalLiquido),
            txdu: formatNumber.format(totalTxDu),
            totalFlyPay: formatNumber.format(totalFlyPay),
            totalVenda: formatNumber.format(totalVenda)
        };
    }

    return (
        <DataTable footerColumnGroup={footerGroup} header={header}
            size="small" rowGroupFooterTemplate={footerTemplate} stripedRows value={bilhetes}
            responsiveLayout="scroll" rowGroupMode="subheader" groupRowsBy="grupo"
            sortMode="single" sortOrder={1} rowGroupHeaderTemplate={headerTemplate} scrollable scrollHeight="500px" scrollDirection="both" >
            <Column bodyStyle={{ width: '400px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '400px' }} field="passageiro" header="PASSAGEIRO"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={dataEmissaoBodyTemplate} header="EMISSÃO"></Column>
            <Column bodyStyle={{ width: '200px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '200px' }} field="tktIsolado" header="TKT"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field="locIsolado" header="LOC"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={tarifaBodyTemplate} header="TARIFA R$"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={taxaBodyTemplate} header="TAXA"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={feeBodyTemplate} header="FEE"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={incentivoBodyTemplate} header="INCENTIVO"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={descontoBodyTemplate} header="DESCONTO"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={impostoBodyTemplate} header="IMPOSTO"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={totalVendaBodyTemplate} header="TOTAL VENDA"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={cartoFlaypayBodyTemplate} header="CARTÃO/FLYPAY"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={txacrtBodyTemplate} header="TXA ADM CRT"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={liquidoBodyTemplate} header="LÍQUIDO"></Column>
            <Column bodyStyle={{ width: '150px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '150px' }} field={txduBodyTemplate} header="TX DU/RAV"></Column>
            <Column bodyStyle={{ width: '200px' }} headerStyle={{ backgroundColor: '#041E42', color: 'white', width: '200px' }} field="obsfatura" header="OBSERVAÇÃO"></Column>
        </DataTable>
    );

}

export default TabelaBilhetes;
